import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IQBOPushVendorsDTO from "../models/DTO/IQBOPushVendorsDTO";
import IProcessedBaseDTO from "../models/DTO/IProcessedBaseDTO";
import IQBOConnectVendorsDTO from "@models/DTO/IQBOConnectVendorsDTO";
import IVendor_Source from "../models/IVendor_Source";

const pushQboVendors = async (
    options: IQBOPushVendorsDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<IProcessedBaseDTO> => {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.QBOPushVendors });
    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(options),
    });

    if (!response.ok) {
        throw new Error(`Failed to push vendors: ${response.statusText}`);
    }

    return response.json();
};

const connectQboVendors = async (options: IQBOConnectVendorsDTO, userModel: IUserUI, supplierModel: ISupplierModel) => {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.QBOConnectVendors });
    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(options),
    });

    if (!response.ok) {
        throw new Error(`Failed to connect vendors: ${response.statusText}`);
    }

    return response.json() as Promise<IProcessedBaseDTO>;
};

const getVendorSources = async (name: string, userModel: IUserUI, supplierModel: ISupplierModel): Promise<IVendor_Source[]> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.GetVendorSources,
        query: { name },
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch vendor sources: ${response.statusText}`);
    }

    const data = await response.json();
    return data.vendorSources || [];
};

const VendorSourceService = {
    pushQboVendors,
    connectQboVendors,
    getVendorSources,
};

export default VendorSourceService;
